(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eb-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eb-faq')) {
    class EbFaq extends HTMLElement {
      #onClick = (event) => {
        const trigger = event.target.closest('.eb-faq__trigger');
        if (!trigger || !this.contains(trigger)) return;

        const item = trigger.closest('.eb-faq__item');
        const open = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      connectedCallback() {
        this.addEventListener('click', this.#onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.#onClick);
      }
    }

    customElements.define('eb-faq', EbFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vtb-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vtb-faq')) {
    class VtbFaq extends HTMLElement {
      #onClick = (event) => {
        const trigger = event.target.closest('.vtb-faq__trigger');
        if (!trigger || !this.contains(trigger)) return;

        const item = trigger.closest('.vtb-faq__item');
        const open = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      connectedCallback() {
        this.addEventListener('click', this.#onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.#onClick);
      }
    }

    customElements.define('vtb-faq', VtbFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vtp-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vtp-faq')) {
    class VtpFaq extends HTMLElement {
      #onClick = (event) => {
        const trigger = event.target.closest('.vtp-faq__trigger');
        if (!trigger || !this.contains(trigger)) return;

        const item = trigger.closest('.vtp-faq__item');
        const open = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      connectedCallback() {
        this.addEventListener('click', this.#onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.#onClick);
      }
    }

    customElements.define('vtp-faq', VtpFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vtp-whats-included"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vtp-stats')) {
    class VtpStats extends HTMLElement {
      #observer = null;

      connectedCallback() {
        // Reduced motion: final values, and no observer at all.
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          for (const el of this.#numbers()) {
            el.textContent = Number(el.dataset.vtpCount) || 0;
          }
          return;
        }

        // JS present: show 0 until the row first enters view.
        for (const el of this.#numbers()) el.textContent = '0';

        this.#observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                this.#start();
                this.#observer.unobserve(entry.target);
              }
            }
          },
          { threshold: 0.5 }
        );
        this.#observer.observe(this);
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
      }

      #numbers() {
        return this.querySelectorAll('[data-vtp-count]');
      }

      #start() {
        for (const el of this.#numbers()) {
          const target = Number(el.dataset.vtpCount) || 0;
          this.#count(el, target);
        }
      }

      #count(el, target) {
        const duration = 2400;
        let startTime = null;

        const step = (now) => {
          if (startTime === null) startTime = now;
          const progress = Math.min((now - startTime) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(target * eased);
          if (progress < 1) requestAnimationFrame(step);
        };

        el.textContent = '0';
        requestAnimationFrame(step);
      }
    }

    customElements.define('vtp-stats', VtpStats);
  }

  } catch(e) { console.error(e); }
})();
})();
